import { render, staticRenderFns } from "./RedemptionHints.vue?vue&type=template&id=23f48ad8&scoped=true"
import script from "./RedemptionHints.vue?vue&type=script&lang=js"
export * from "./RedemptionHints.vue?vue&type=script&lang=js"
import style0 from "./RedemptionHints.vue?vue&type=style&index=0&id=23f48ad8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f48ad8",
  null
  
)

export default component.exports